import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import Confirm from 'views/confirm/confirm'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import interactiveVideoActions from 'redux/actions/interactiveVideoActions'
import { localize } from 'helpers/translator'

const InteractiveVideoCancelConfirm = props => (
	<Confirm
		btOne={localize('global_no')}
		btTwo={localize('global_yes')}
		alertMessage={localize('interactive_video_cancel_confirm')}
		actionButtonType={0}
		actionOne={props.actions.cancelReject}
		actionTwo={props.actions.cancelConfirm}
		closeAction={props.actions.cancelReject}
	/>
)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		cancelReject: interactiveVideoActions.cancelInteractiveRejected,
		cancelConfirm: interactiveVideoActions.cancelInteractiveConfirmed,
	}, dispatch)
}

InteractiveVideoCancelConfirm.propTypes = {
	actions: PropTypes.shape({
		cancelReject: PropTypes.func.isRequired,
		cancelConfirm: PropTypes.func.isRequired,
	}),
}

export default connect(null, mapDispatchToProps)(InteractiveVideoCancelConfirm)

export { InteractiveVideoCancelConfirm }
